export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left - Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <div className="w-full h-[500px]">
                <img
                  src="https://public.readdy.ai/ai/img_res/033630b768c9d09844ea549d6dee1eaf.jpg"
                  alt="Our professional team"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div className="absolute -bottom-6 -right-6 bg-teal-600 text-white p-8 rounded-xl shadow-xl">
              <div className="text-5xl font-bold mb-1">10+</div>
              <div className="text-sm font-medium">years in business</div>
            </div>
          </div>

          {/* Right - Content */}
          <div>
            <div className="inline-block px-4 py-2 bg-teal-100 text-teal-700 rounded-full text-sm font-semibold mb-6">
              About Us
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight" style={{ fontFamily: 'Poppins, sans-serif' }}>
              El Paso's Most <strong>Trusted Cash Home Buyers</strong>
            </h2>
            
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Since 2016, we've been helping El Paso homeowners sell their properties quickly and hassle-free. Whether you're <a href="/avoid-foreclosure" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">facing foreclosure</a>, dealing with an <a href="/inherited-homes" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">inherited property</a>, going through a divorce, or simply need to relocate fast, we provide fair cash offers and close on your timeline.
            </p>

            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Unlike traditional real estate agents, we buy houses directly from homeowners in any condition. This means no repairs, no showings, no waiting months for a buyer, and absolutely no commissions or hidden fees. We handle all the paperwork and make the entire process as smooth as possible. As <a href="/elpaso-tx" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">El Paso's trusted local buyers</a>, we understand the unique challenges homeowners face in our community. Stay informed about the latest developments by visiting our <a href="/local-news-el-paso-texas" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">El Paso real estate news</a> section.
            </p>

            <div className="grid sm:grid-cols-2 gap-6 mb-8">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center">
                  <i className="ri-shield-check-fill text-teal-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">TRex RE LLC is an end buyer</h3>
                  <p className="text-sm text-gray-600">We are not a middle man. Unlike wholesalers we actually are real estate investors with a portfolio.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center">
                  <i className="ri-hand-heart-fill text-teal-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">Fair & Honest</h3>
                  <p className="text-sm text-gray-600">We provide transparent offers based on current market values. We have a real track record in El Paso TX</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center">
                  <i className="ri-time-fill text-teal-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">Fast Closings</h3>
                  <p className="text-sm text-gray-600">Close in as little as 7 days or on your preferred timeline</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center">
                  <i className="ri-customer-service-2-fill text-teal-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">Local Experts</h3>
                  <p className="text-sm text-gray-600">Deep knowledge of El Paso neighborhoods and property values</p>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-4">
              <a href="#contact" className="inline-flex items-center space-x-2 px-8 py-4 bg-teal-600 text-white rounded-lg font-bold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer">
                <span>Get Your Offer</span>
                <i className="ri-arrow-right-line"></i>
              </a>
              <a href="tel:+1-915-206-5814" className="inline-flex items-center space-x-2 px-8 py-4 bg-teal-600 text-white rounded-lg font-bold text-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-phone-fill"></i>
                <span>Call (915) 206-5814</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}